import * as Model from '../../model/types';
import {ForwardGraphStorage, ForwardOp} from './types';

export class RefStorage implements ForwardGraphStorage {
  private roots = new Set<ForwardOp>();
  private ops = new Map<Model.Op, ForwardOp>();

  getRoots(): Set<ForwardOp> {
    return this.roots;
  }

  getOp(op: Model.Op): ForwardOp | undefined {
    return this.ops.get(op);
  }

  setOp(op: ForwardOp) {
    this.ops.set(op.op, op);
  }
}
